import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "submenu" }
const _hoisted_2 = { class: "submenu" }
const _hoisted_3 = { class: "submenu" }

import { useRoute } from 'vue-router';
// import { workspaceData } from "@/static/workspaceData";
// import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkSpaceMenu',
  setup(__props) {

const route = useRoute();
const { workspaceId } = route.params;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", null, [
    _createElementVNode("li", null, [
      _createVNode(_component_router_link, {
        to: `/workspace/${_unref(workspaceId)}/dashboard`
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "icon-dashboard" }, null, -1),
          _createElementVNode("p", { class: "outfit" }, "Dashboard", -1)
        ])),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_router_link, {
        to: `/workspace/${_unref(workspaceId)}/schedule/monthly`
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "icon-schedule" }, null, -1),
          _createElementVNode("p", { class: "outfit" }, "Schedule", -1)
        ])),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/schedule/monthly`
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "icon-monthly" }, null, -1),
              _createElementVNode("p", { class: "outfit" }, "Monthly", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/schedule/weekly`
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "icon-weekly" }, null, -1),
              _createElementVNode("p", { class: "outfit" }, "Weekly", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_router_link, {
        to: `/workspace/${_unref(workspaceId)}/chat`
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "icon-chat" }, null, -1),
          _createElementVNode("p", { class: "outfit" }, "Chat", -1)
        ])),
        _: 1
      }, 8, ["to"])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("li", null, [
      _createVNode(_component_router_link, {
        to: `/workspace/${_unref(workspaceId)}/scrum/task/kanban`
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "icon-scrum" }, null, -1),
          _createElementVNode("p", { class: "outfit" }, "Scrum", -1)
        ])),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/scrum/sprint/list`
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("div", null, [
                _createElementVNode("i", { class: "icon-sprint" })
              ], -1),
              _createElementVNode("p", { class: "outfit" }, "Sprint", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/scrum/task/kanban`
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "icon-task" }, null, -1),
              _createElementVNode("p", { class: "outfit" }, "Task", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/scrum/issue/list`
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("div", null, [
                _createElementVNode("i", { class: "icon-sprint" })
              ], -1),
              _createElementVNode("p", { class: "outfit" }, "Issue", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/scrum/meeting/list`
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "icon-meeting" }, null, -1),
              _createElementVNode("p", { class: "outfit" }, "Meeting", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("li", null, [
      _createVNode(_component_router_link, {
        to: `/workspace/${_unref(workspaceId)}/scrum/board/qa/list`
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createElementVNode("i", { class: "icon-board" }, null, -1),
          _createElementVNode("p", { class: "outfit" }, "Board", -1)
        ])),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/scrum/board/qa/list`
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "icon-qa" }, null, -1),
              _createElementVNode("p", { class: "outfit" }, "QA Board", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: `/workspace/${_unref(workspaceId)}/scrum/board/error/list`
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("i", { class: "icon-errors" }, null, -1),
              _createElementVNode("p", { class: "outfit" }, "Errors", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}
}

})